export const isAbsoluteUrl = (url = '') => {
  const reg = /^https?:\/\//i;
  return Boolean(reg.test(url));
};
